import { v4 as uuidv4 } from 'uuid';

function setViewFunc (viewFunc) {
    this.viewFunc = viewFunc;
    this.observed.viewFunc = uuidv4();
}

export function removeViewFunc () {
    this.viewFunc = null;
    this.observed.viewFunc = uuidv4();
}

export default setViewFunc;
